/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RefreshRequestDto
 */
export interface RefreshRequestDto {
    /**
     * 
     * @type {string}
     * @memberof RefreshRequestDto
     */
    refreshToken?: string | null;
}

/**
 * Check if a given object implements the RefreshRequestDto interface.
 */
export function instanceOfRefreshRequestDto(value: object): value is RefreshRequestDto {
    return true;
}

export function RefreshRequestDtoFromJSON(json: any): RefreshRequestDto {
    return RefreshRequestDtoFromJSONTyped(json, false);
}

export function RefreshRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefreshRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'refreshToken': json['refreshToken'] == null ? undefined : json['refreshToken'],
    };
}

export function RefreshRequestDtoToJSON(json: any): RefreshRequestDto {
    return RefreshRequestDtoToJSONTyped(json, false);
}

export function RefreshRequestDtoToJSONTyped(value?: RefreshRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'refreshToken': value['refreshToken'],
    };
}

